import { useEffect } from 'react';

// Design system
import { Message } from 'jl-design-system/components/message/Message';

// Types
import { PaymentCardDeletedMessagesProps } from './PaymentCardDeletedMessages.types';

// Config
import errorCodeConstants from '@constants/errorCodeConstants';
import getErrorMessageObject from '@utils/error/getErrorMessageObject';

// Components
import Container from '@components/container';

const PaymentCardDeletedMessages = ({
  onLoad = () => {},
  paymentCardDeleteApiCallFailed = false,
  paymentCardDeleted,
}: PaymentCardDeletedMessagesProps) => {
  useEffect(() => {
    onLoad();
  }, []);

  let messageProps;

  if (paymentCardDeleteApiCallFailed) {
    const cardDeleteFailedErrorMessage = getErrorMessageObject({
      error: { code: errorCodeConstants.CLIENT_CARD_DELETE_FAILED },
    });

    messageProps = {
      body: cardDeleteFailedErrorMessage?.body,
      dataId: 'saved-cards-delete-error',
      dataTestId: 'saved-cards-delete-error',
      type: 'error',
      title: cardDeleteFailedErrorMessage?.message,
    };
  } else if (paymentCardDeleted) {
    messageProps = {
      dataId: 'saved-cards-delete-success',
      dataTestId: 'saved-cards-delete-success',
      type: 'success',
      title: `Your payment card ending in ${paymentCardDeleted} has been successfully deleted`,
    };
  }

  return (
    messageProps && (
      <Container marginBottom="2">
        <Message {...messageProps} scrollToMessageOnMount />
      </Container>
    )
  );
};

export default PaymentCardDeletedMessages;
